import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control form-control-lg"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function Textarea({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  form,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  custom,
  full,
  hide,
  ...props
}) {
  return (
    <>
      {full === "full" ? (
        <>
          {label && (
            <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>
          )}
          <div className="col-lg-12 col-xl-12">
            <textarea
              type={type}
              style={{ height: "500px" }}
              name={field.name}
              placeholder={props.placeholder}
              className={getFieldCSSClasses(
                touched[field.name],
                errors[field.name]
              )}
              {...field}
              {...props}
            />
            {withFeedbackLabel && (
              <FieldFeedbackLabel
                error={errors[field.name]}
                touched={touched[field.name]}
                label={label}
                type={type}
                customFeedbackLabel={customFeedbackLabel}
              />
            )}
          </div>
        </>
      ) : (
        <>
          {custom === "custom" ? (
            <>
              {label && (
                <label className="col-xl-3 col-lg-3 col-form-label">
                  {label}
                </label>
              )}
              <div className="col-lg-12 col-xl-12">
                <textarea
                  type={type}
                  name={field.name}
                  placeholder={props.placeholder}
                  className={getFieldCSSClasses(
                    touched[field.name],
                    errors[field.name]
                  )}
                  {...field}
                  {...props}
                />
                {withFeedbackLabel && (
                  <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    type={type}
                    customFeedbackLabel={customFeedbackLabel}
                  />
                )}
              </div>
            </>
          ) :  hide === "hide" ? (
            <>
              {label && (
                <label className="col-xl-3 col-lg-3 col-form-label">
                  {label}
                </label>
              )}
              <div className="col-lg-9 col-xl-6">
                <textarea
                  type={type}
                  name={field.name}
                  placeholder={props.placeholder}
                  className={"form-control form-control-lg"}
                  {...field}
                  {...props}
                />
                {withFeedbackLabel && (
                  <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    type={type}
                    customFeedbackLabel={customFeedbackLabel}
                  />
                )}
              </div>
            </>
          ) :(
            <>
              {label && (
                <label className="col-xl-3 col-lg-3 col-form-label">
                  {label}
                </label>
              )}
              <div className="col-lg-6 col-xl-6">
                <textarea
                  type={type}
                  name={field.name}
                  placeholder={props.placeholder}
                  className={getFieldCSSClasses(
                    touched[field.name],
                    errors[field.name]
                  )}
                  {...field}
                  {...props}
                />
                {withFeedbackLabel && (
                  <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    type={type}
                    customFeedbackLabel={customFeedbackLabel}
                  />
                )}
              </div>
            </>
          )}
        </>
      )}
      {/* {label && <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>}
      <div className="col-lg-9 col-xl-6">
      <textarea
        type={type}
        name={field.name}
        placeholder={props.placeholder}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
      </div> */}
    </>
  );
}

export function TextAreaSplit({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  form,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  custom,
  full,
  ...props
}) {
  return (
    <>
      {label && <label>{label}</label>}
    
      <textarea
        type={type}
        name={field.name}
        placeholder={props.placeholder}
        className={getFieldCSSClasses(
          touched[field.name],
          errors[field.name]
        )}
        {...field}
        {...props}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
  </>
  );
}


export function TextareaTolak({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  form,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  custom,
  full,
  hide,
  ...props
}) {
  return (
    <>
        <>
          <div className="col-lg-12 col-xl-12">
            <textarea
              type={type}
              style={{ height: "200px" }}
              name={field.name}
              placeholder={props.placeholder}
              className={getFieldCSSClasses(
                touched[field.name],
                errors[field.name]
              )}
              {...field}
              {...props}
            />
            {withFeedbackLabel && (
              <FieldFeedbackLabel
                error={errors[field.name]}
                touched={touched[field.name]}
                label={label}
                type={type}
                customFeedbackLabel={customFeedbackLabel}
              />
            )}
          </div>
        </>
    </>
  );
}
export function TextareaRequired({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  form,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  custom,
  full,
  hide,
  ...props
}) {
  return (
    <>
      {full === "full" ? (
        <>
          {label && (
            <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>
          )}
          <div className="col-lg-12 col-xl-12">
            <textarea
              type={type}
              style={{ height: "500px" }}
              name={field.name}
              placeholder={props.placeholder}
              className={getFieldCSSClasses(
                touched[field.name],
                errors[field.name]
              )}
              {...field}
              {...props}
            />
            {withFeedbackLabel && (
              <FieldFeedbackLabel
                error={errors[field.name]}
                touched={touched[field.name]}
                label={label}
                type={type}
                customFeedbackLabel={customFeedbackLabel}
              />
            )}
          </div>
        </>
      ) : (
        <>
          {custom === "custom" ? (
            <>
              {label && (
                <label className="col-xl-3 col-lg-3 col-form-label">
                  {label}
                </label>
              )}
              <div className="col-lg-12 col-xl-12">
                <textarea
                  type={type}
                  name={field.name}
                  placeholder={props.placeholder}
                  className={getFieldCSSClasses(
                    touched[field.name],
                    errors[field.name]
                  )}
                  {...field}
                  {...props}
                />
                {withFeedbackLabel && (
                  <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    type={type}
                    customFeedbackLabel={customFeedbackLabel}
                  />
                )}
              </div>
            </>
          ) :  hide === "hide" ? (
            <>
              {label && (
                <label className="col-xl-3 col-lg-3 col-form-label">
                  {label}
                </label>
              )}
              <div className="col-lg-9 col-xl-6">
                <textarea
                  type={type}
                  name={field.name}
                  placeholder={props.placeholder}
                  className={"form-control form-control-lg"}
                  {...field}
                  {...props}
                />
                {withFeedbackLabel && (
                  <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    type={type}
                    customFeedbackLabel={customFeedbackLabel}
                  />
                )}
              </div>
            </>
          ) :(
            <>
              {label && (
                <label className="col-xl-3 col-lg-3 col-form-label">
                  {label}
                  <span
        // style={{
        //   color: "red",
        //   fontSize: "20px",
        //   position: "absolute",
        // }}
        style={{
          color: "red",
          fontSize: "14px", // smaller font size for superscript
          verticalAlign: "super", // makes it superscript
          position: "static", // remove absolute to avoid layout issues
        }}
      >
        &nbsp;*
      </span>
                </label>
              )}
              <div className="col-lg-6 col-xl-6">
                <textarea
                  type={type}
                  name={field.name}
                  placeholder={props.placeholder}
                  className={getFieldCSSClasses(
                    touched[field.name],
                    errors[field.name]
                  )}
                  {...field}
                  {...props}
                />
                {withFeedbackLabel && (
                  <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    type={type}
                    customFeedbackLabel={customFeedbackLabel}
                  />
                )}
              </div>
            </>
          )}
        </>
      )}
      {/* {label && <label className="col-xl-3 col-lg-3 col-form-label">{label}</label>}
      <div className="col-lg-9 col-xl-6">
      <textarea
        type={type}
        name={field.name}
        placeholder={props.placeholder}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
      </div> */}
    </>
  );
}